import { Component } from '@angular/core';

@Component({
  selector: 'app-mobile-warning',
  template: `
    <div class="mobile-warning">
      <div class="logo">
        <img src="../../../assets/img/vhi_logo.png" alt="Talonic Logo" />
      </div>
      <div class="message">
        <h2>Desktop Only Application</h2>
        <p>We apologize, but this application is optimized for desktop use only.</p>
        <p>Please access Talonic from a desktop computer for the best experience.</p>
      </div>
    </div>
  `,
  styles: [`
    .mobile-warning {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      min-height: 100vh;
      padding: 12px;
      text-align: center;
      background-color: #f8f9fa;
    }

    .logo {
      margin-bottom: 24px;
      padding: 0 8px;
    }

    .logo img {
      width: 120px;
      height: auto;
      max-width: 100%;
    }

    .message {
      width: 100%;
      max-width: 296px;
      padding: 0 8px;
    }

    h2 {
      color: #333;
      margin-bottom: 16px;
      font-size: 20px;
      font-weight: 600;
    }

    p {
      color: #666;
      margin-bottom: 8px;
      line-height: 1.3;
      font-size: 14px;
    }
  `],
  standalone: true
})
export class MobileWarningComponent {} 